import React from 'react'
import {
  ChildrenShape
} from 'shapes'
import './index.css'

export default function AreaHint (props) {
  return (
    <div className="area-hint">
      {props.children}
    </div>
  )
}

AreaHint.propTypes = {
  children: ChildrenShape
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/area-hint/index.js